import React from 'react';
import './About.css';

const PORTRAIT_WIDTHS = [320, 480, 960, 1440];

const portraitSrcSet = (ext) =>
  PORTRAIT_WIDTHS.map((w) => `/_img/about/eleonora-${w}.${ext} ${w}w`).join(', ');

const About = () => {
  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="about-content">
          <div className="about-header-with-image">
            <picture>
              <source type="image/avif" srcSet={portraitSrcSet('avif')} sizes="360px" />
              <source type="image/webp" srcSet={portraitSrcSet('webp')} sizes="360px" />
              <img
                src="/_img/about/eleonora-960.jpg"
                srcSet={portraitSrcSet('jpg')}
                sizes="360px"
                alt="Элеонора Тестова"
                className="about-image"
              />
            </picture>

            <div className="about-info-block">
              <h2 className="about-name">ЭЛЕОНОРА ТЕСТОВА</h2>
              <p className="about-title">дизайнер интерьеров</p>
              <p className="about-experience">более 5 лет опыта</p>
              <a href="https://t.me/el_testova" className="about-contact-btn" target="_blank" rel="noopener noreferrer">
                Связаться
              </a>
            </div>

            {/* <h3 className="about-section-title">ОБО МНЕ</h3> */}

            <p className="about-text">
              Я - дизайнер интерьера с многолетним опытом. Начинала карьеру в студии, а со временем перешла на самостоятельную практику. Сейчас сопровождаю проекты на всех этапах - от первой встречи с заказчиком до финальной фотосъемки готового интерьера, включая комплектацию и полное ведение стройки.
            </p>

            <p className="about-text">
              Работаю с квартирами, загородными домами и коммерческими помещениями. Для меня важно не просто создать красивое пространство, а сделать его удобным, продуманным и живым - таким, которое действительно отражает своих хозяев.
            </p>

            <p className="about-text">
              Я люблю как лаконичные монохромные интерьеры, так и смелые, наполненные цветом. И стремлюсь к тому, чтобы интерьер был цельным и выразительным - в каждом элементе, в каждой детали.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
